<template>
    <div class="class-list p-b-64 page">
        <van-row style="background-color: white; padding: 10px 0px">
            <van-col v-for="(btn, index) in BUTTON_LIST" :key="index" style="flex: 1" span="8">
                <div class="tab-item"
                     @click="PUSH({name: 'approve-list',query: {type: BUTTON_LIST[index].type, time: new Date().getTime(), unRead: BUTTON_LIST[index].count > 0}})">
                    <div style="position: relative;overflow: visible">
                        <img class="tab-item-img"
                             :src="BUTTON_LIST[index].icon"/>
                        <div v-if="BUTTON_LIST[index].count > 0" class="tab-item-badge">
                            <div class="van-info van-badge__info">{{BUTTON_LIST[index].count}}</div>
                        </div>
                    </div>
                    <div class="tab-item-txt">{{BUTTON_LIST[index].label}}</div>
                </div>
            </van-col>
        </van-row>

        <div v-if="indicatorType" style="height: 80vh; display: flex; flex-direction: row; align-items: center">
            <indicatorEmpty :type="indicatorType" :message="indicatorMessage"></indicatorEmpty>
        </div>

        <van-collapse v-else v-model="activeNames"
                      style="padding: 0 13px 0 13px">
            <van-collapse-item v-for="(group, i) in groupList"
                               :key="i"
                               :title="group.groupName"
                               class="bd-van-collapse-item"
                               :name="group.id">
                <div v-if="!showType">
                    <van-row>
                        <van-col v-for="(approve, n) in group.approveList"
                                 :key="n"
                                 span="6">
                            <div class="approve-item" :style="{'padding-top': (n < 4 ? 20 : 0) + 'px'}"
                                 @click="goCreate(approve)">
                                <img class="approve-item-img"
                                     :src="iconMap[approve.iconType]"/>
                                <div class="approve-item-txt">{{approve.approveName}}</div>
                            </div>
                        </van-col>
                    </van-row>
                </div>
                <div v-else>
                    <van-row>
                        <van-col v-for="(approve, n) in group.approveList"
                                 :key="n"
                                 span="24">
                            <div class="approve-item-h"
                                 @click="goCreate(approve)">
                                <img class="approve-item-img-h"
                                     :src="iconMap[approve.iconType]"/>
                                <div class="approve-item-txt-h" style="margin-left: 10px">{{approve.approveName}}</div>
                            </div>
                        </van-col>
                    </van-row>
                </div>
            </van-collapse-item>
        </van-collapse>
    </div>
</template>

<script>
    import head from '../../mixins/head';
    import indicatorEmpty from './empty';

    export default {
        components: {
            indicatorEmpty
        },
        name: 'approve',
        mixins: [head],
        data() {
            return {
                BUTTON_LIST: [
                    {
                        label: '我审批的',
                        // icon: require('../../assets/img/index/我审批的.png'),
                        icon: require('../../assets/img/index/001@2x.png'),
                        count: 0,
                        type: 1
                    },
                    {
                        label: '我发起的',
                        // icon: require('../../assets/img/index/我发起的.png'),
                        icon: require('../../assets/img/index/002@2x.png'),
                        count: 0,
                        type: 2
                    },
                    {
                        label: '抄送我的',
                        // icon: require('../../assets/img/index/抄送我的.png'),
                        icon: require('../../assets/img/index/003@2x.png'),
                        count: 0,
                        type: 3
                    },
                    {
                        label: '转发给我',
                        // icon: require('../../assets/img/index/转发给我.png'),
                        icon: require('../../assets/img/index/004@2x.png'),
                        count: 0,
                        type: 5
                    },
                    {
                        label: '归档',
                        // icon: require('../../assets/img/index/归档.png'),
                        icon: require('../../assets/img/index/005@2x.png'),
                        count: 0,
                        type: 4
                    }
                ],
                groupList: [],
                iconMap: {},
                activeNames: [],
                collapseNames: [],
                allNames: [],
                approveCount: 0,
                notifyCount: 0,
                forwardCount: 0,
                unExpandNames: [],
                indicatorType: 0,
                indicatorMessage: '',
                showType: false
            };
        },
        props: {
            data: {
                type: Array,
                default: function () {
                    return [];
                }
            }
        },
        watch: {
            '$route': 'inited',
            'activeNames': function (val, oval) {
                if (val != oval) {
                    this.collapseNames.splice(0, this.allNames.length);
                    for (let i = 0; i < this.allNames.length; i++) {
                        let exist = false;
                        for (let j = 0; j < this.activeNames.length; j++) {
                            if (this.allNames[i] == this.activeNames[j]) {
                                exist = true;
                                break;
                            }
                        }
                        if (!exist) {
                            this.collapseNames.push(this.allNames[i]);
                        }
                    }
                    console.log('activeNames', this.collapseNames);
                    this.$storage.set('COLLAPSE', JSON.stringify(this.collapseNames));
                }
            }
        },
        computed: {},
        created() {
            this.getUserBaseInfo();
        },
        mounted() {
            window.help = () => {
                this.$toast({
                    duration: 1000,
                    message: '你点击了帮助按钮'
                });
            };
            window.showAsGrid = () => {
                this.showType = false;
                this.$storage.set('SHOW_TYPE', this.showType);
            };
            window.showAsList = () => {
                this.showType = true;
                this.$storage.set('SHOW_TYPE', this.showType);
            };
            this.inited();
            this.init();
        },
        methods: {
            inited() {
                if (this.$route.name == 'approve') {
                    window.moreButton({
                        btnName: '切换',
                        children: [{
                            btnName: '网格显示',
                            action: 'showAsGrid'
                        }, {
                            btnName: '列表显示',
                            action: 'showAsList'
                        }]
                    });
                    this.$toast.clear();
                    this.setTitle('审批');
                    this.getApproveCount();
                    this.getNotifyCount();
                    this.getForwardCount();
                }
            },

            init() {
                let A = this.$storage.get('COLLAPSE');
                let B = this.$storage.get('SHOW_TYPE');
                console.log('init B====>', B);
                B = JSON.parse(B);
                if (A) {
                    this.collapseNames.push(...JSON.parse(A));
                }
                if (B) {
                    this.showType = B;
                } else if (this.$store.state.companyId == 381) {
                    this.showType = true;
                }
                console.log('init showType====>', this.showType);
                this.getData();
                this.getIcon();
            },

            getData() {
                this.$toast.loading({
                    duration: 0,
                    loadingType: 'spinner',
                    forbidClick: true
                });
                let param = { groupType: 0 };
                this.$http.post('badu/eaa/queryReadApproveList.do', param, { toast: true })
                    .then((response) => {
                        this.$toast.clear();
                        this.initData(response.data);
                    })
                    .catch((error) => {
                        this.indicatorType = error.rspCode == -100 && (error.status != 403 || error.status != 500) ? 1 : 3;
                        this.indicatorMessage = error.rspMsg;
                    });
            },

            getIcon() {
                let param = {};
                this.$http.post('common/queryMobileIconImageList.do', param)
                    .then((response) => {
                        this.iconMap = response.data;
                    });
            },

            getUserBaseInfo() {
                let param = {
                    profileId: this.$store.state.userInfo.profileId,
                    companyId: this.$store.state.companyId
                };
                this.$http.post('profile/getUserBaseInfo.do', param)
                    .then((response) => {
                        let added = false;
                        for (let i = 0; i < this.BUTTON_LIST.length; i++) {
                            if (this.BUTTON_LIST[i].type == -1) {
                                added = true;
                                break;
                            }
                        }
                        if (!added) {
                            if (response.data && response.data.authList && response.data.authList.length) {
                                let authList = response.data.authList;
                                let hasAuth = false;
                                for (let i = 0; i < authList.length; i++) {
                                    if (authList[i] == 'STANDARD_APPROVE_MANAGE') {
                                        hasAuth = true;
                                        break;
                                    }
                                }
                                if (hasAuth) {
                                    this.$store.commit('hasApproveManage', true);
                                    console.log('hasApproveManage', this.$store.state.hasApproveManage);
                                    this.BUTTON_LIST.push({
                                        label: '所有流程',
                                        // icon: require('../../assets/img/index/归档.png'),
                                        icon: require('../../assets/img/index/005@2x.png'),
                                        count: 0,
                                        type: -1
                                    });
                                }
                            }
                        }
                    });
            },

            initData(data) {
                this.groupList.splice(0, this.groupList.length);
                if (data && data.length) {
                    for (let i = 0; i < data.length; i++) {
                        if (data[i].approveList && data[i].approveList.length && !data[i].approveList[0].endType) {
                            this.groupList.push(data[i]);
                            this.allNames.push(data[i].id);
                            let isCollapse = false;
                            for (let j = 0; j < this.collapseNames.length; j++) {
                                if (data[i].id == this.collapseNames[j]) {
                                    isCollapse = true;
                                    break;
                                }
                            }
                            if (!isCollapse) {
                                this.activeNames.push(data[i].id);
                            }
                        }
                    }
                }
                // console.log('data', this.$data);
                if (this.groupList.length) {
                    this.indicatorType = 0;
                } else {
                    this.indicatorType = 2;
                    this.indicatorMessage = '请联系管理员创建审批模板';
                }
            },

            getApproveCount() {
                let param = {};
                this.$http.post('badu/eaa/countNeedMeApprove.do', param)
                    .then((response) => {
                        console.log('getApproveCount', response.data);
                        this.approveCount = response.data;
                        this.BUTTON_LIST[0].count = response.data;
                    });
            },

            getNotifyCount() {
                let param = {};
                this.$http.post('badu/eaa/countNotifyMeApproveUnRead.do', param)
                    .then((response) => {
                        console.log('getNotifyCount', response.data);
                        this.notifyCount = response.data;
                        this.BUTTON_LIST[2].count = response.data;
                    });
            },

            getForwardCount() {
                let param = {};
                this.$http.post('badu/eaa/countTranspondMeApproveUnRead.do', param)
                    .then((response) => {
                        console.log('getNotifyCount', response.data);
                        this.forwardCount = response.data;
                        this.BUTTON_LIST[3].count = response.data;
                    });
            },

            openWindow(url) {
                window.openWindow(url);
            },

            goCreate(approve) {
                if (approve.approveType == '2') {
                    this.PUSH({ name: 'flow-create', query: { id: approve.id, title: approve.approveName } });
                } else {
                    this.PUSH({ name: 'approve-create', query: { id: approve.id, title: approve.approveName } });
                }
            }
        }
    };
</script>

<style lang="scss" scoped>
    @import '../../assets/scss/approve.scss';

    .col-item {
    }

    .tab-item {
        padding: 10px 5px;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .tab-item-img {
        height: 48px;
        width: 48px;
    }

    .tab-item-txt {
        font-size: 13px;
        color: #596C83;
        margin-top: 1px;
    }

    .approve-item {
        padding: 0px 5px 20px 5px;
        text-align: center;
    }

    .approve-item-h {
        padding: 10px 0px;
        display: flex;
        flex-direction: row;
        align-items: center;
        min-height: 50px;
        position: relative;
    }

    .approve-item-h:after {
        content: "";
        position: absolute;
        bottom: 0px;
        left: 0px;
        right: 0px;
        border-bottom: 1px solid #f5f5f5;
        -webkit-transform: scaleY(.5);
        -webkit-transform-origin: 0 0;
    }

    .approve-item-img {
        height: 50px;
        width: 50px;
        border-radius: 5px;
    }

    .approve-item-img-h {
        height: 25px;
        width: 25px;
        border-radius: 2px;
    }

    .approve-item-txt {
        font-size: 13px;
        color: #596C83;
        line-height: 16px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-top: 4px;
    }

    .approve-item-txt-h {
        font-size: 13px;
        color: #666666;
        line-height: 16px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .tab-item-badge {
        position: absolute;
        top: 6px;
        right: 6px;
        /*border-radius: 16px;*/
        /*min-width: 16px;*/
        /*padding: 0px 4px 0px 4px;*/
        /*height: 16px;*/
        /*font-size: 12px;*/
        /*color: white;*/
        /*background-color: #f44;*/
        /*text-align: center;*/
    }

    .bd-van-collapse-item {
        background: #fff;
        margin-top: 10px;
        text-align: left;
        border-radius: 5px;
        overflow: hidden;

        .van-collapse-item__title {
            min-height: 50px;
            align-items: center;
            color: #666;
        }

        .van-collapse-item__content {
            padding: 0 20px;
        }

    }
</style>
